<template>
    <div class="invalid-feedback field-errors" style="display:block;">
        <ul>
            <li v-for="ek  in errors[name]" :key="ek">
                {{ek}}
            </li>
        </ul>
    </div>
</template>
<script>

export default{
    props: {
        errors: Object,
        name: String
    }
}

</script>